"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.personaFactory = exports.personaUserFactory = exports.personaEmailFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const profile_image_factory_1 = require("../../common/factories/profile-image.factory");
const persona_1 = require("../../../mocks/persona");
const phone_number_factory_1 = require("./phone-number.factory");
const address_factory_1 = require("./address.factory");
const alert_preference_factory_1 = require("./alert-preference.factory");
const mobile_phone_factory_1 = require("../../Ngin/factories/mobile-phone.factory");
exports.personaEmailFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    address: persona_1.persona.email,
    label: null,
    enabled: true,
    alerts: true,
    is_primary: true,
});
exports.personaUserFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    uri: Factory.each(i => `https://user.sportngin.com.dev/users/${i + 1}`),
    user_name: 'testuser',
    first_name: persona_1.persona.first_name,
    last_name: persona_1.persona.last_name,
    uuid: Factory.each(() => uuid_1.v4()),
    is_activated: true,
    external_identity_provider: false,
    email_addresses: exports.personaEmailFactory.buildList(1),
    profile_images: profile_image_factory_1.profileImageFactory.buildList(1),
    phone_numbers: phone_number_factory_1.phoneNumberFactory.buildList(1),
    self_persona: null,
    alert_preferences: alert_preference_factory_1.alertPreferenceFactory.buildList(1),
    full_name: 'Pu Fullnam',
    mobile_phone: mobile_phone_factory_1.mobilePhoneFactory.build(),
    primary_email: persona_1.persona.email,
    addresses: address_factory_1.addressFactory.buildList(1)
});
exports.personaFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    first_name: persona_1.persona.first_name,
    middle_name: null,
    last_name: persona_1.persona.last_name,
    date_of_birth: persona_1.persona.date_of_birth,
    gender: persona_1.persona.gender,
    nickname: null,
    suffix: null,
    country_of_birth: null,
    played_outside_us: null,
    disability: null,
    graduation_year: null,
    military_status: null,
    persona_listenee: false,
    citizenship_countries: [],
    ethnicities: [],
    uri: Factory.each(i => `https://user.sportngin.com.dev/personas/${i + 1}`),
    type: 'self',
    addresses: address_factory_1.addressFactory.buildList(1),
    phone_numbers: phone_number_factory_1.phoneNumberFactory.buildList(1),
    profile_images: persona_1.persona.profile_image,
    email_addresses: exports.personaEmailFactory.buildList(1),
    user: exports.personaUserFactory.build(),
    verified_information: [],
    guardian_users: exports.personaUserFactory.buildList(1),
    orphan_invite_id: Factory.each(i => i + 1),
    owner_mobile_phone: mobile_phone_factory_1.mobilePhoneFactory.build(),
    owner_primary_email: persona_1.persona.email,
    owner_user: exports.personaUserFactory.build(),
});
